export const userSettingsPageRoute = '/user-settings';
export const userSettingsNotificationsPageRoute = '/user-settings/notifications';
export const userSettingsNotificationsCommunitiesPageRoute = '/user-settings/notifications/communities';

export const userSettingsRoutes = [
  userSettingsPageRoute,
  userSettingsNotificationsPageRoute,
  userSettingsNotificationsCommunitiesPageRoute,
];
